import { Component, Vue } from 'vue-property-decorator';
import PazAttributesDialog from "@pazion/pazion-catalog/src/components/dialog/PazOrderAttributeDialog.vue"
import AttributesTab from "@pazion/pazion-catalog/src/components/dialog/tabs/AttributesTab.vue";
import {getAccountAttributes} from '@pazion/pazion-catalog/src/services/catalog-service';


@Component({
  components: {
    PazAttributesDialog,
    AttributesTab
  }
})
export default class AccountAttributesMixin extends Vue {

  public accountAttributeNames = [];
  public showAttributesModal: boolean = false;

  async showAttributeModal(selectedAccount: any) {
  this.selectedAccount = selectedAccount;
    this.showAttributesModal = true;
    this.accountAttributeNames = await getAccountAttributes();
  }

  getAttributesCount(item: any) {
    return item && item.attributeValue.length > 0 ?
        item.attributeValue.length : false;
  }




}//